export const getColumnOfRegion = (wholeMixRegion, region) => () => {
    const indexToColumnPosition = {
        0: 'left',
        1: 'right',
    };
    const columnIndex = wholeMixRegion.data.layout.rows[0].columns.reduce((resultingIndex, column, index) => {
        if (column.regionIds.includes(region.regionId)) {
            return index;
        }
        return resultingIndex;
    }, 0);
    return indexToColumnPosition[columnIndex];
};
const MAX_GAP_WIDTH_BY_COLUMN_COUNT = {
    2: 60,
    3: 40,
    4: 30,
};
export const balanceGapsBetweenColumns = (leftColumnPadding, rightColumnPadding, numberOfColumns) => {
    const totalGap = parseInt(leftColumnPadding, 10) + parseInt(rightColumnPadding, 10);
    const finalGap = Math.min(totalGap, MAX_GAP_WIDTH_BY_COLUMN_COUNT[numberOfColumns]);
    const paddingRemainder = (finalGap || 0) % 2;
    const [right, left] = [
        Math.floor(finalGap / 2) + paddingRemainder,
        Math.floor(finalGap / 2),
    ];
    return { right, left };
};
export const calculateColumnDesktopDisplayWidth = ({ columns, messageContentWidth, outerPadding, innerPadding, leftColumnPadding, rightColumnPadding, isRtl, }) => {
    const leftoverWidth = 100 - columns.reduce((acc, curr) => (acc = acc + curr.width), 0);
    const numberOfColumns = columns.length;
    const availableSpace = messageContentWidth - (outerPadding.left + outerPadding.right);
    const parsedLeftColumnPadding = parseInt(leftColumnPadding, 10);
    const parsedRightColumnPadding = parseInt(rightColumnPadding, 10);
    const contentSpace = calculateMixContentSpace({
        numberOfColumns,
        messageContentWidth,
        outerPadding,
        innerPadding,
        leftColumnPadding,
        rightColumnPadding,
    });
    return columns.map((column, idx, all) => {
        const spaceForColumn = contentSpace * ((column.width || 50) / 100);
        const firstColumnPadding = isRtl ? innerPadding.right : innerPadding.left;
        const lastColumnPadding = isRtl ? innerPadding.left : innerPadding.right;
        if (idx === 0) {
            return {
                width: column.width,
                displayWidth: `${((spaceForColumn + firstColumnPadding + parsedLeftColumnPadding) *
                    100) /
                    availableSpace}%`,
            };
        }
        else if (idx === all.length - 1) {
            return {
                width: column.width,
                displayWidth: `${((spaceForColumn + lastColumnPadding + parsedRightColumnPadding) *
                    100) /
                    availableSpace}%`,
            };
        }
        else {
            return {
                width: column.width,
                displayWidth: `${((spaceForColumn +
                    (contentSpace / 100) * leftoverWidth +
                    parsedLeftColumnPadding +
                    parsedRightColumnPadding) *
                    100) /
                    availableSpace}%`,
            };
        }
    });
};
export const calculateMixContentSpace = ({ numberOfColumns, messageContentWidth, outerPadding, innerPadding, leftColumnPadding, rightColumnPadding, }) => {
    const availableSpace = messageContentWidth - (outerPadding.left + outerPadding.right);
    const innerSpaceAfterAlignment = availableSpace - (innerPadding.right + innerPadding.left);
    const paddingSpace = (numberOfColumns - 2) * (leftColumnPadding + rightColumnPadding) +
        leftColumnPadding +
        leftColumnPadding;
    const contentSpace = innerSpaceAfterAlignment - paddingSpace;
    return contentSpace;
};
//# sourceMappingURL=utils.js.map